export class Constants {
    // DEVELOPMENT
    // public static REST_ENDPOINT = 'http://localhost:8080/DoocentiELearningPlatform-API/services/rest/';
    // public static API_ENDPOINT = 'http://localhost:8080/DoocentiELearningPlatform-API/services/api/';
    // public static MEDIA_ENDPOINT = 'http://localhost:8080/DoocentiELearningPlatform-API/services/media/';

    // PRODUCTION
    public static REST_ENDPOINT = 'https://elearning-api.doocenti.com/services/rest/';
    public static API_ENDPOINT = 'https://elearning-api.doocenti.com/services/api/';
    public static MEDIA_ENDPOINT = 'https://elearning-api.doocenti.com/services/media/';

    // ID certificazioni TFA Sostegno: 20, 21 (Sviluppo) | 20, 30, 31, 32 (Produzione)
    public static readonly TFA_SOSTEGNO_CERTIFICAZIONE_IDS: number[] = [20, 21, 30, 31, 32];

    // Timer Simulatore TFA (in secondi)
    public static readonly TFA_SIMULATOR_TIMER_SECONDS: number = 7200; // 120 minuti
    public static readonly TFA_SIMULATOR_TIMER_ALERT_SECONDS: number = 300; // 5 minuti
}
